/** useWebSocket — minimal hook to subscribe to WaveScorePro WS topics.
 *  Auto-reconnects on close. */
import { useEffect, useRef } from "react";

export function useWebSocket(topics, onMessage) {
  const wsRef = useRef(null);
  const reconnectTimer = useRef(null);
  const handlerRef = useRef(onMessage);
  handlerRef.current = onMessage;

  useEffect(() => {
    let stopped = false;

    const connect = () => {
      const httpUrl = process.env.REACT_APP_BACKEND_URL || "";
      const wsUrl = httpUrl.replace(/^http/, "ws") + "/api/ws";
      const ws = new WebSocket(wsUrl);
      wsRef.current = ws;

      ws.onopen = () => {
        (topics || []).forEach((t) => {
          try { ws.send(JSON.stringify({ action: "subscribe", topic: t })); } catch {}
        });
      };
      ws.onmessage = (evt) => {
        try {
          const msg = JSON.parse(evt.data);
          handlerRef.current?.(msg);
        } catch {}
      };
      ws.onclose = () => {
        if (stopped) return;
        // Auto-reconnect after 3s
        reconnectTimer.current = setTimeout(connect, 3000);
      };
      ws.onerror = () => { try { ws.close(); } catch {} };
    };

    connect();
    return () => {
      stopped = true;
      if (reconnectTimer.current) clearTimeout(reconnectTimer.current);
      try { wsRef.current?.close(); } catch {}
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(topics || [])]);
}
